'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['buffer'],
    data: function data() {
        return {
            banlist: [],
            is_refreshing: false
        };
    },
    created: function created() {
        this.updateBanlist();
    },
    methods: {
        updateBanlist: function updateBanlist() {
            var _this = this;

            if (this.buffer.getNetwork().state !== 'connected' || this.is_refreshing) {
                return;
            }

            var channelName = this.buffer.name;
            this.is_refreshing = true;
            this.buffer.getNetwork().ircClient.banlist(channelName, function (banEvent) {
                _this.banlist = banEvent.bans;
                _this.is_refreshing = false;
            });
        },
        removeBan: function removeBan(mask) {
            var channelName = this.buffer.name;
            this.buffer.getNetwork().ircClient.unban(channelName, mask);
            this.banlist = this.banlist.filter(function (ban) {
                return ban.banned !== mask;
            });
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ChannelBanlist"]
window._kiwi_exports.components.ChannelBanlist = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ChannelBanlist.vue
// module id = rPJe
// module chunks = 1